// src/components/support.js

// Primary support address
export const SUPPORT_EMAIL = 'support@creativepracticesolutions.com';

// Defaults for convenience (customize anytime)
export const DEFAULT_SUBJECT = 'SmartnoteMD Support';
export const DEFAULT_BODY =
  'Please describe the issue and include your username.';

// Prebuilt mailto link with default subject/body
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${
  encodeURIComponent(DEFAULT_SUBJECT)
}&body=${encodeURIComponent(DEFAULT_BODY)}`;

/**
 * Build a custom mailto link to support.
 * Usage:
 *   const href = buildSupportMailto({
 *     subject: 'Login issue',
 *     body: 'I cannot sign in with username: ...',
 *     cc: 'ops@creativepracticesolutions.com',
 *     bcc: 'audit@creativepracticesolutions.com',
 *   });
 *   <a href={href}>Email Support</a>
 */
export function buildSupportMailto({
  subject = DEFAULT_SUBJECT,
  body = DEFAULT_BODY,
  cc,
  bcc,
} = {}) {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  if (cc) params.set('cc', cc);
  if (bcc) params.set('bcc', bcc);
  return `mailto:${SUPPORT_EMAIL}?${params.toString()}`;
}

// Optional default export (handy for quick imports)
export default {
  SUPPORT_EMAIL,
  DEFAULT_SUBJECT,
  DEFAULT_BODY,
  SUPPORT_MAILTO,
  buildSupportMailto,
};
